import { describeCron } from "../lib/describeCron";
import {
  type TriggerType,
  triggerTypeIcons,
  triggerTypeLabels,
  workflowScheduleCrons,
  workflowTriggerTypes,
} from "../lib/workflowTrigger";
import { ConnectorLogoContainer } from "./ConnectorLogoContainer";
import { FacePile } from "./FacePile";
import { Icon } from "./Icon";
import { Tooltip } from "./Tooltip";

function triggerTooltip(type: TriggerType, crons: string[]): string {
  if (type === "scheduled" && crons.length > 0) {
    return crons.map(describeCron).join(", ");
  }
  return triggerTypeLabels[type];
}

export function TriggerTypes({
  branches,
}: {
  branches: Parameters<typeof workflowTriggerTypes>[0];
}) {
  const types = workflowTriggerTypes(branches);
  if (types.length === 0) return null;
  const crons = workflowScheduleCrons(branches);

  return (
    <FacePile
      itemSize={24}
      outlineWidth={2}
      cutout
      items={types.map((type) => ({
        id: type,
        label: triggerTypeLabels[type],
        bare: true,
        node: (
          <Tooltip content={triggerTooltip(type, crons)}>
            <ConnectorLogoContainer size={24} outline={false} outlineWidth={2}>
              <Icon
                name={triggerTypeIcons[type]}
                size={12}
                color="var(--text-secondary)"
              />
            </ConnectorLogoContainer>
          </Tooltip>
        ),
      }))}
    />
  );
}
